import React from 'react';
import {DateTime} from 'luxon';
import {useSelector} from 'react-redux';
import NumberFormat from 'react-number-format';

const NewBookingDetails = (props) => {

    const getItin = () => {
    	let itinState = false;
    	if(props.booking.bookingOverview.hasOwnProperty('itineraryName')){
    		if(props.booking.bookingOverview.itineraryName!==''&&props.booking.bookingOverview.itineraryName!==null&&props.booking.bookingOverview.itineraryName!=='null'){
    			itinState = true;
    		}
    	}
    	return itinState;
    }

    const getFormattedDate = (dateToFormat, noDaysOfTheWeek) => {
        let formattedDate
        if (noDaysOfTheWeek) {
            formattedDate = DateTime.fromISO(dateToFormat).toFormat('MMMM d, yyyy');
        } else {
            formattedDate = DateTime.fromISO(dateToFormat).toLocaleString(DateTime.DATE_HUGE);
        }
    	return formattedDate;
    }

    const capitalizeWords = (str) => {
        return str.split(" ")
                .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                .join(" ");
    }

    const handleKeydown = (e) => {
        if (e.key === 'Enter') {
            props.onChangeView('paymentview', props.booking, props.booking.hash, props.updateBooking);
        }
    }

    const handleOnChangeViewToPayment = () => {
        props.onChangeView('paymentview', props.booking, props.booking.hash, props.updateBooking)
    }

    const remainingBalanceNegative = useSelector(state => state.remainingBalanceNegative);
    const remainingBalance = props.updateBooking.bookingSummary.charges.remainingBalance;
    const isApiCruisLines = props.apiCruisLines.includes(props.updateBooking.bookingOverview.cruise.cruiseLineName);
    const isNonLuxPayOnline = props.updateBooking.bookingSummary.charges.remainingBalance!=='0.0' && 
                            props.updateBooking.bookingSummary.charges.balanceExcludeFuturePayments!==0 && 
                            props.updateBooking.bookingSummary.charges.balanceExcludeFuturePayments >=25 && 
                            props.apiCruisLines.includes(props.updateBooking.bookingOverview.cruise.cruiseLineName);
    const isNonLuxFullyPaid = props.updateBooking.bookingSummary.charges.remainingBalance === '0.0' ||  props.updateBooking.bookingSummary.charges.remainingBalance === 0;
    const isNonLuxRemainingBalance = remainingBalanceNegative === true || props.updateBooking.bookingSummary.charges.remainingBalance === 0 || remainingBalance === 0;
    const linkPaymentNonLuxText = isNonLuxPayOnline ? 'Make or view scheduled payments' : 'View payment';
    const paymentDueDate = getFormattedDate(props.updateBooking.bookingSummary.charges.paymentDueDate, true);


    return (
        // SUMMARY PAGE BOOKING DETAILS: TOP ON MOBILE, LEFT RIGHT ON DESKTOP
        <div id='cssSummaryDetails' class="wth3-bookingDetails">
            <div id='cssSummaryDetailsContent' class="wth3-bookingDetails__content">
                <div id='cssSummaryDisembarkDate' class="wth3-bookingDetails__content-disembarkDate" style={{position: 'absolute', left: '-999px'}} aria-description="disembark date">
                    {getFormattedDate(props.booking.bookingSummary.returnDate, false)}
                </div>
                {/* Greeting */}
                <div id='cssSummaryGreeting' class="wth3-bookingDetails__content-greeting">
                    <h1 id='cssSummaryGreetingName' class="wth3-bookingDetails__content-greeting-name">Hi {capitalizeWords(props.booking.bookingSummary.guestList[0].firstName)},</h1> 
                </div>



                {/* Luxury customers with and w/out insurance */}
                {!isApiCruisLines && remainingBalance !== 0 &&
                    <div id='cssSummaryPayment' class="wth3-bookingDetails__content-payment lux-call-to">
                        <div id='cssSummaryPaymentContnet' class="wth3-bookingDetails__content-payment-info">
                            <span id='cssSummaryPaymentDueData' class='wth3-bookingDetails__content-payment-info-due-date'>Payment due by {paymentDueDate}</span>
                            <span id='cssMakeScheduledPaymentCallTo' class='wth3-bookingDetails__content-payment-info-callTo'>Please call <a href={`tel:${props.showPhoneNumber}`} id='cssMakeScheduledPaymentLinkMobile' class='wth3-bookingDetails__content-payment-info-callTo-link wth3-phoneMobileView'>{props.showPhoneNumber}</a><div id='cssMakeScheduledPaymentLinkDesktop' class='wth3-bookingDetails__content-payment-info-callTo-link wth3-phoneDesktopView'>{props.showPhoneNumber}</div> to make a payment or add travel insurance</span>
                        </div>
                        <div id='cssSummaryDivider' className="wth3-bookingDetails__content-payment-dividerLine"></div>
                        <div id='cssSummaryPaymentAction' class="wth3-bookingDetails__content-payment-action">
                            <span id='cssSummaryPaymentBalance' class="wth3-bookingDetails__content-payment-action-balance-text">Remaining balance</span>
                            {remainingBalanceNegative === false && remainingBalance !== 0 &&
                                <span id='cssSummaryPaymentBalanceAmount' class="wth3-bookingDetails__content-payment-action-balance-amount"><NumberFormat value={remainingBalance} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} /></span>
                            }
                        </div>
                    </div> 
                }
                
                {/* Non luxury customers remaining balance above 25 with display payment block if below will not display */}
                {!isNonLuxFullyPaid && isNonLuxPayOnline && isApiCruisLines ?
                    (<div id='cssSummaryPayment' class="wth3-bookingDetails__content-payment nonLux-call-to" role='link' tabIndex={0}
                        onClick={e => {e.preventDefault(); handleOnChangeViewToPayment();}}
                        onKeyDown={e => {handleKeydown(e);}}
                    >
                        <div id='cssSummaryPaymentContnet' class="wth3-bookingDetails__content-payment-info">
                            <span id='cssSummaryPaymentDueData' class='wth3-bookingDetails__content-payment-info-due-date'>Payment due by {paymentDueDate}</span>
                            <span id='cssMakeScheduledPaymentText' class='wth3-bookingDetails__content-payment-info-link'>{linkPaymentNonLuxText}</span>
                        </div>
                        <div id='cssSummaryDivider' className="wth3-bookingDetails__content-payment-dividerLine"></div>
                        <div id='cssSummaryPaymentAction' class="wth3-bookingDetails__content-payment-action">
                            <span id='cssSummaryPaymentBalance' class="wth3-bookingDetails__content-payment-action-balance-text">Remaining balance</span>
                            {remainingBalanceNegative === false && remainingBalance !== 0 &&
                                <span id='cssSummaryPaymentBalanceAmount' class="wth3-bookingDetails__content-payment-action-balance-amount"><NumberFormat value={remainingBalance} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} /></span>
                            }
                        </div>
                    </div>) :

                    // Non luxury customers, remaining balance under $25 and cannot make payment online 
                    !isNonLuxPayOnline && !isNonLuxRemainingBalance && isApiCruisLines &&
                        (<div id='cssSummaryPayment' class="wth3-bookingDetails__content-payment nonLux-call-to" role='link' tabIndex={0}
                            onClick={e => {e.preventDefault(); handleOnChangeViewToPayment();}}
                            onKeyDown={e => {handleKeydown(e);}}
                        >
                            <div id='cssSummaryPaymentContnet' class="wth3-bookingDetails__content-payment-info">
                                <span id='cssSummaryPaymentDueData' class='wth3-bookingDetails__content-payment-info-due-date'>Payment due by {paymentDueDate}</span>
                                {/* With or w/out insurance */}
                                <span id='cssMakeScheduledPaymentText' class='wth3-bookingDetails__content-payment-info-link'>View payment</span>
                                <span id='cssMakeScheduledPaymentCallTo' class='wth3-bookingDetails__content-payment-info-callTo'>Balances below $25.00 cannot be paid online. To complete your payment, please call at <a href={`tel:${props.showPhoneNumber}`} onClick={(e) => e.stopPropagation()} id='cssMakeScheduledPaymentLinkMobile' class='wth3-bookingDetails__content-payment-info-callTo-link wth3-phoneMobileView'>{props.showPhoneNumber}</a><div id='cssMakeScheduledPaymentLinkDesktop' class='wth3-bookingDetails__content-payment-info-callTo-link wth3-phoneDesktopView'>{props.showPhoneNumber}</div></span>                               
                            </div>
                            <div id='cssSummaryDivider' className="wth3-bookingDetails__content-payment-dividerLine nonLux-call-to-dividerLine"></div>
                            <div id='cssSummaryPaymentAction' class="wth3-bookingDetails__content-payment-action">
                                <span id='cssSummaryPaymentBalance' class="wth3-bookingDetails__content-payment-action-balance-text">Remaining balance</span>
                                {remainingBalanceNegative === false && remainingBalance !== 0 &&
                                    <span id='cssSummaryPaymentBalanceAmount' class="wth3-bookingDetails__content-payment-action-balance-amount"><NumberFormat value={remainingBalance} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} /></span>
                                }
                            </div>
                        </div>) 
                }

                {/* Flex Pay */}
                {   
                    props.getSitePropertyValue('CSS_UPLIFT_ENABLED') === 'Y' && 
                    props.updateBooking.bookingSummary.charges.remainingBalance > 0 &&

                    (
                        (   props.updateBooking.bookingSummary.charges.remainingBalance >= 150 &&  
                            props.updateBooking.bookingSummary.charges.balanceExcludeFuturePayments !== 0 &&
                            props.updateBooking.bookingSummary.charges.balanceExcludeFuturePayments >= 150
                        ) 
                        || 
                        (   props.updateBooking.bookingSummary.quoteInsuranceInd === 'Y' && 
                            props.updateBooking.insuranceQuote.priceAmount >= 150
                        )
                    ) && 

                    props.updateBooking.bookingSummary.charges.remainingBalance <= 15000 && 
                    props.updateBooking.bookingSummary.charges.scheduledPayment === undefined &&

                    <div id='cssSummaryFlexPay' class="wth3-bookingDetails__content-flex-pay">
                        <span id='cssSummaryFlexPayText' class="wth3-bookingDetails__content-flex-pay-text">You may be eligible to split up your final payment into easy monthly installments with Flex Pay. Just select Flex Pay at checkout to pay over time.</span>
                    </div>
                }

                {/* Booking Details */}
                <dl id='cssSummaryBookingDetailsContainer' class="wth3-bookingDetails__content-details">
                    {/* Booking Confirmation */}
                    <div id='cssSummaryConfirmationBox' class="wth3-bookingDetails__content-confirmation">
                        <dt class="wth3-bookingDetails__content-confirmation-title" id="cssSummaryConfirmationLabel">Confirmation number</dt>
                        <dd class='wth3-bookingDetails__content-confirmation-number' id="cssSummaryBookingNumber"><span id="css_partnerCode">{props.siteConfigData.partnercode}</span> - <span id='css_bookingNumber'>{props.updateBooking.bookingNumber}</span></dd>
                    </div>

                    {/* Booking Itinerary */}
                    {getItin() && props.booking.bookingOverview.itineraryName !== 'null' &&
                        <div id='cssSummaryItineraryBox' class="wth3-bookingDetails__content-itinerary">
                            <dt id="cssSummaryItinTitle" class="wth3-bookingDetails__content-itinerary-title">Your cruise</dt>
                            <dd id="cssSummaryItinName" class="wth3-bookingDetails__content-itinerary-name">
                                {props.booking.bookingOverview.itineraryName}
                            </dd>
                        </div>    
                    }

                    {/* Booking Cruiseline */}
                    <div id='cssSummaryCruiselineBox' class="wth3-bookingDetails__content-cruiseline">
                        <dt id="cssSummaryCruiseLineTitle" class='wth3-bookingDetails__content-cruiseline-title'>Cruise line</dt> 
                        <dd id="css_cruiseLineName" class='wth3-bookingDetails__content-cruiseline-name'>{props.booking.bookingOverview.cruise.cruiseLineName}</dd>
                    </div>

                    {/* Booking Ship Name */}
                    <div id='cssSummaryShipBox' class="wth3-bookingDetails__content-shipName">
                        <dt id="cssSummaryShipTitle" class='wth3-bookingDetails__content-shipName-title'>Cruise ship</dt> 
                        <dd id="css_vesselName" class="wth3-bookingDetails__content-shipName-name">{props.booking.bookingOverview.cruise.vesselName}</dd>
                    </div>

                    {/* Booking Cruiseline Confirmation # */}
                    <div id='cssSummaryBookConfirmBox' class="wth3-bookingDetails__content-cruiselineConfirmation">
                        <dt id="cssSummaryCruiselineConfirmTitle" class='wth3-bookingDetails__content-cruiselineConfirmation-title'>{props.booking.bookingOverview.cruise.cruiseLineName} confirmation number</dt> 
                        <dd id="cssSummaryCruiselineConfirmName" class="wth3-bookingDetails__content-cruiselineConfirmation-number">{props.booking.bookingOverview.cruise.venRes}</dd>
                    </div>

                    {/* Booking Departure Date */}
                    <div id='cssSummaryDepartDateBox' class="wth3-bookingDetails__content-departureDate">
                        <dt id="cssSummaryDepartDateTitle" class='wth3-bookingDetails__content-departureDate-title'>Departure date</dt> 
                        <dd id="css_departureDate" class="wth3-bookingDetails__content-departureDate-date">{getFormattedDate(props.booking.bookingOverview.departureDate, false)}</dd>
                    </div>

                    {/* Booking Guests */}
                    <div id='cssSummaryGuestsBox' class="wth3-bookingDetails__content-guests">
                        <dt id="cssSummaryGuestsTitle" class='wth3-bookingDetails__content-guests-title'>Guests</dt> 
                        {props.booking.bookingOverview.guestNames.map((guestName, index) => (
                            <dd id={`cssSummaryGuestsName_${index}`} class="wth3-bookingDetails__content-guests-name">
                                {capitalizeWords(guestName)}
                            </dd>
                        ))}
                    </div>

                </dl>

                {
                    props.siteZendeskID && props.siteZendeskID !== undefined && props.siteZendeskID !== null && props.siteZendeskID !== '' ?
                        <div id='cssSummaryChangeReservationBox' class="wth3-bookingDetails__content-changeReservation">To make any changes to your reservation please chat with us now or call us at {" "}
                            <a id="cssSummaryAdminPhoneNumberToCall" href={`tel:${props.showPhoneNumber}`} className="wth3-bookingDetails__content-changeReservation-linkNumber wth3-phoneMobileView" onClick={() => {props.CallTracker("Customer Self Service", "Booking Summary", "Click-To-Call")}}>
                                {props.showPhoneNumber}
                            </a>
                            <div id="cssSummaryAdminPhoneNumberToCall" className="wth3-bookingDetails__content-changeReservation-linkNumber wth3-phoneDesktopView">
                                {props.showPhoneNumber}
                            </div>
                        </div> 
                    : <div id='cssSummaryChangeReservationBox' class="wth3-bookingDetails__content-changeReservation">To make any changes to your reservation please chat with us now or call us at {" "}
                        <a id="cssSummaryAdminPhoneNumberToCall" href={`tel:${props.showPhoneNumber}`} className="wth3-bookingDetails__content-changeReservation-linkNumber wth3-phoneMobileView" onClick={() => {props.CallTracker("Customer Self Service", "Booking Summary", "Click-To-Call")}}>
                            {props.showPhoneNumber}
                        </a>
                        <div id="cssSummaryAdminPhoneNumberToCall" className="wth3-bookingDetails__content-changeReservation-linkNumber wth3-phoneDesktopView">
                            {props.showPhoneNumber}
                        </div>
                    </div>
                }
            </div>
        </div>
    )
}

export default NewBookingDetails;